import Button from 'core/components/buttons/Button'
import Icon from 'core/components/icons/Icon'
import Field from 'core/components/form/Field'
import Input from 'core/components/inputs/Input'
import useLocalStorage from 'core/hooks/utils/useLocalStorage'
import React, { useCallback, useMemo, useState } from 'react'
import useAuth from 'core/hooks/auth/useAuth'

interface TestAccount {
  auth_token: string
  email: string
}

const ProdAccountsTab = () => {
  const { switchSession } = useAuth()

  const [accounts, setAccounts] = useLocalStorage<TestAccount[]>(
    'prod_accounts',
    []
  )
  const [email, setEmail] = useState('')
  const [authToken, setAuthToken] = useState('')
  const [query, setQuery] = useState('')

  const filteredAccounts = useMemo(() => {
    return query
      ? accounts.filter(({ email }) => {
          return email.toLocaleLowerCase().includes(query?.toLocaleLowerCase())
        })
      : accounts
  }, [accounts, query])

  const reloadWithNewAuthToken = useCallback(async () => {
    setAccounts([
      ...accounts,
      {
        auth_token: authToken,
        email
      }
    ])
    await switchSession(authToken)
    setTimeout(() => {
      window.location.reload()
    }, 500)
  }, [accounts, setAccounts, email, authToken, switchSession])

  return (
    <>
      <p className="text-base text my-3">Prod accounts.</p>

      {!!accounts.length && (
        <>
          <Input
            type="text"
            placeholder="Search account"
            className="w-full"
            value={query}
            suffix={'search'}
            onChange={(event) => {
              const value = event.currentTarget.value
              setQuery(value || '')
            }}
          />
          <div className="mt-3 max-h-[50vh] overflow-auto">
            <div className="mt-5">
              <span className="font-semibold text-lg">
                Production Accounts{' '}
              </span>
              <div className="flex flex-col gap-3 mt-3 pr-2">
                {!filteredAccounts.length && query && <p>No accounts found</p>}

                {filteredAccounts.map((account) => {
                  return (
                    <div
                      key={account.auth_token}
                      className="flex items-center justify-between gap-2"
                    >
                      <p className="text-left truncate">{account.email}</p>

                      <div className="flex items-center gap-3">
                        <Icon
                          name="vehicle"
                          color="text-everlance-primary"
                          className="cursor-pointer w-4"
                          onClick={async () => {
                            await switchSession(account.auth_token)
                            setTimeout(() => {
                              window.location.reload()
                            }, 500)
                          }}
                        />

                        <span className="bg-dark-5 w-[2px] h-5" />
                        <Icon
                          name="trash-outline"
                          color="text-danger"
                          className="cursor-pointer w-4"
                          onClick={() => {
                            setAccounts(
                              accounts.filter(
                                (item) => item.auth_token !== account.auth_token
                              )
                            )
                          }}
                        />
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </>
      )}
      <br />
      <hr />
      <div className="mt-5">
        <span className="font-semibold text-lg">New account</span>
        <div className="mt-5">
          <div className="flex flex-col gap-2">
            <Field className="mb-1!">
              <Input
                placeholder="Email"
                className="w-full"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value)
                }}
              />
            </Field>
            <Field className="mb-1!">
              <Input
                placeholder="Auth token"
                className="w-full"
                value={authToken}
                onChange={(e) => {
                  setAuthToken(e.target.value)
                }}
              />
            </Field>
          </div>
          <div className="flex justify-end mt-3">
            <Button
              variant="primary"
              disabled={!email || !authToken}
              onClick={reloadWithNewAuthToken}
            >
              Save and reload
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}

export default React.memo(ProdAccountsTab)
